@if (localUser.userData) {
    <mat-card class="tw-flex tw-justify-between !tw-resize tw-overflow-auto">
        <div>
            <mat-card-header class="tw-flex tw-justify-between tw-items-center">
                <mat-card-title>Portal AI Document Bot</mat-card-title>
                <button (click)="closeDialog()" mat-icon-button>
                    <mat-icon class="m3-error">close</mat-icon>
                </button>
            </mat-card-header>
            <mat-card-content class="tw-grid tw-h-[500px]">
                @if ((chatLoading$ | async) && !chat && !threadMenuOpen) {
                    <mat-spinner class="tw-place-self-center" [diameter]="50" />
                }

                <ng-container *ngIf="chat$ | async as chat">
                    <div
                        #scrollContainer
                        class="tw-flex tw-flex-col tw-gap-2 tw-overflow-y-auto"
                    >
                        <ng-container
                            *ngFor="
                                let msg of messages;
                                let i = index;
                                trackBy: trackByCreated
                            "
                        >
                            <app-chat-message
                                [msg]="msg"
                                [predecessor]="
                                    i - 1 >= 0 ? messages[i - 1] : null
                                "
                                [localUser]="localUser"
                            />
                        </ng-container>

                        <app-typing-indicator
                            [aiBuffering]="aiBuffering$ | async"
                        />
                    </div>
                </ng-container>
            </mat-card-content>
        </div>
        <app-chat-controls
            class="tw-w-full"
            (sendMessage)="sendMessage($event)"
            [aiBuffering$]="aiBuffering$"
        />
    </mat-card>
}
